<template>
  <el-dialog :title="OfferTitle" :visible.sync="OfferShow" :width="dialogType == 'Processing' ? '548px' : '500px'" @close="DialogSwitch" :class="[dialogType == 'Processing' ? 'processing' : '', dialogType == 'Processing' ? (CardInfo.SRStatus > 1 ? 'processed' : '') : '']">
    <div :class="['dialog_box', 'dialog_box_' + dialogType, dialogType == 'Processing' ? (CardInfo.SRStatus > 1 ? 'height114' : 'height204') : '']">
      
      <!-- Answer/NewOffer -->
      <div v-if="dialogType == 'Answer' || dialogType == 'NewOffer'">
        <div class="offer_block">
          <div :class="['offer_buyer']">
            <el-avatar class="user_avatar" :src="CardInfo.BuyHeadPortrait ? CardInfo.BuyHeadPortrait + $store.state.thumbnail : '/static/images/noimg.svg'"></el-avatar>
            {{ CardInfo.BuyRealName }}
            <span v-if="dialogType == 'NewOffer'">: $ {{ CardInfo.USD_BuyPrice }}</span>
          </div>
          <div class="offer_buyer_price" v-if="dialogType == 'Answer'">
            <div class="offer-view">{{ $t('enum.buyerOffer') }}</div>
            <div>USD <em class="offer_price">{{ CardInfo.USD_BuyPrice }}</em></div>
          </div>
        </div>
        <div class="offer_block" v-if="dialogType == 'NewOffer'">
          <div>{{ $t('enum.myNewOffer') }}</div>
          <div class="sh_ipt my_new_offer">
            USD<el-input class="enter_price" v-model="OfferPrice" placeholder="0"></el-input>
          </div>
          <div class="offer_remark">
            <el-input type="textarea" :placeholder="$t('tips.enterOfferRemark')" :rows="5" v-model="Remark" maxlength="250" show-word-limit :autosize="{ minRows: 2, maxRows: 6 }"></el-input>
          </div>
        </div>

        <div class="sh_fee">
          <div class="offer_title">{{ $t('enum.myPrice') }}:</div>
          <div class="offer_val">USD {{ CardInfo.USD_Price }}</div>
        </div>
        <div class="sh_fee text_gray">
          <div class="offer_title">{{ $t('enum.minimumOfferAmount') }}:</div>
          <div class="offer_val">USD {{ CardInfo.USD_LPrice }}</div>
        </div>
        <div class="sh_fee text_gray">
          <div class="offer_title">{{ $t('enum.autoAccept') }}:</div>
          <div class="offer_val">USD {{ CardInfo.USD_HPrice }}</div>
        </div>
        <div class="sh_fee">
          <div class="offer_title">{{ $t('enum.EndedTime') }}:</div>
          <div class="offer_val">{{ $store.getters.getTime(CardInfo.FailureTime) }}</div>
        </div>

      </div>
      <!-- OfferHistory -->
      <div v-else-if="dialogType == 'OfferHistory'">
        <div class="my-price">
          <div class="sh_fee_o">
            <div>{{ $t('enum.myPrice') }}</div>
            <div>USD {{ CardInfo.USD_Price }}</div>
          </div>
          <div class="sh_fee_o">
            <div>{{ $t('enum.minimumOfferAmount') }}</div>
            <div>USD {{ CardInfo.USD_LPrice }}</div>
          </div>
          <div class="sh_fee_o">
            <div>{{ $t('enum.autoAccept') }}</div>
            <div>USD {{ CardInfo.USD_HPrice }}</div>
          </div>
        </div>
        <div class="sh_fee_p">
          <el-table :data="OfferList" style="width: 100%;" height="200">
            <el-table-column prop="RealName" :label="$t('enum.offerFrom')">
            </el-table-column>
            <el-table-column :label="$t('enum.offerPrice')">
              <template slot-scope="scope">
                USD {{ scope.row.US_Price }}
              </template>
            </el-table-column>
            <el-table-column :label="$t('enum.remark')">
              <template slot-scope="scope">
                <div class="tab-row">{{ scope.row.Remark }}</div>
              </template>
            </el-table-column>
            <el-table-column prop="Createdate" :label="$t('enum.time')">
              <template slot-scope="scope">
                {{ $store.getters.getTime(scope.row.Createdate, $store.state.lang.indexOf("zh") > -1 ? 8 : -8) }}
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
      <!-- 维权 -->
      <div v-else-if="dialogType == 'Processing'" class="processing-main">
        <div class="order_index_box">
          <div class="order_index">
            <div class="title_color1">
              {{ CardInfo.OrderDetail ? $store.getters.getTime(CardInfo.OrderDetail.CreateDate, $store.state.lang.indexOf("zh") > -1 ? 8 : -8) : '' }}
            </div>
            <div>
              <span class="title_color1">{{ $t('enum.orderNumber') }}:</span>
              <span class="color_333">{{ CardInfo.OrderCode }}</span>
            </div>
            <div class="order-user">
              <img v-if="CardInfo.HeadPortrait" class="seller_img" :src="CardInfo.HeadPortrait + $store.state.thumbnail">
              <el-avatar v-if="!CardInfo.HeadPortrait" class="seller_img" fit="fit" icon="el-icon-user-solid" size="small"></el-avatar>
              <span class="color_333">{{ CardInfo.OrderDetail ? CardInfo.OrderDetail.BuyerName : '' }}</span>
            </div>
          </div>
          <div v-if="CardInfo.OrderDetail">
            <div class="commodity_index_box">
              <div class="commodity_img" @click="dialogBox('ViewDetails', CardInfo.OrderDetail)">
                <img v-if="CardInfo.OrderDetail.Details[0].TitImg" :src="CardInfo.OrderDetail.Details[0].TitImg + $store.state.thumbnail">
                <span class="commodity_num" v-if="CardInfo.OrderDetail.Details.length > 1">{{ CardInfo.OrderDetail.Details.length }}
                  {{ $t('enum.items') }}</span>
              </div>
              <div class="commodity_index">
                <h1 class="color_333 commodity_title" @click="dialogBox('ViewDetails', CardInfo.OrderDetail)">
                  {{ CardInfo.OrderDetail.Details[0].Title }}</h1>
                <div class="Process_box">
                  <div class="Order_price color_333">{{ $t('enum.orderTotal') }}:
                    <span>USD {{ CardInfo.OrderDetail.USDRate ? (CardInfo.OrderDetail.LowestPrice * CardInfo.OrderDetail.USDRate + CardInfo.OrderDetail.PostageMoney * CardInfo.OrderDetail.USDRate).toFixed(2) : 0 }}</span>
                  </div>
                  <!-- {{CardInfo['SRBtnType']}}，{{CardInfo['SRBtnType']}}， -->
                  <!-- <div class="Process color_333" v-if="CardInfo['SRStatus']">{{$store.state.SafeRightStatus[CardInfo['SRStatus']]}}</div> -->
                  <div class="Process process-btn color_333" v-if="CardInfo['SRBtnType'] > 0" @click="ChangeSRBtnType(CardInfo['SRBtnType'])">
                    {{ SRBtnType(CardInfo['SRBtnType']) }}
                  </div>
                  <div class="Process noClick" :class="[CardInfo['SRStatus'] == 3 ? 'text_gray' : 'color_333']" @click="noClick" v-if="CardInfo['SRStatus'] >= 2 && CardInfo['SRBtnType'] == 0">
                    {{ CardInfo['SRStatus'] == 2 ? $t('status.completed') : $t('status.caseClosed') }}
                  </div>
                </div>
              </div>
            </div>
          </div>

        </div>
        <div class="Processing_box">
          <div v-for="(obj, key) in CardInfo.objs" :key="key">
            <span class="title_color1 time">{{ $store.getters.getTime(obj.CreateDate, $store.state.lang.indexOf("zh") > -1 ? 8 : -8) }}</span>
            <div :class="[obj.SRUserID == $store.state.UserInfo.Id || obj.SRUserID == $store.state.UserInfo.MappingUserId ? 'user_reply' : 'seller_reply']">
              <img :src="obj.SRUserImage + $store.state.thumbnail">
              <div :class="[obj.SRUserID == $store.state.UserInfo.Id || obj.SRUserID == $store.state.UserInfo.MappingUserId ? 'user_reply_box' : 'seller_reply_box']">
                <span v-if="obj.SRUserID != $store.state.UserInfo.Id && obj.SRUserID != $store.state.UserInfo.MappingUserId" class="more"></span>
                <div class="text">
                  <span>{{ obj.Title }}</span>
                  <div class="text_img reply" v-if="obj.Images">
                    <swiper class="swiper" :options="swiperOption">
                      <swiper-slide class="like_slide" v-for="(img, k) in obj['Images']" :key="k">
                        <el-image class="like_img" :src="img + $store.state.thumbnail" fit="contain" :preview-src-list="obj.Images">
                        </el-image>
                      </swiper-slide>
                    </swiper>
                  </div>
                </div>
                <span v-if="obj.SRUserID == $store.state.UserInfo.Id || obj.SRUserID == $store.state.UserInfo.MappingUserId" class="more"></span>
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>
    <span slot="footer" class="dialog-footer">
      <div v-if="dialogType == 'NewOffer'">
        <!-- //新议价 -->
        <el-button @click="DialogSwitch">{{ $t('button.cancel') }}</el-button>
        <el-button type="primary" @click="OfferSave">{{ $t('button.save') }}</el-button>
      </div>
      <div v-else-if="dialogType == 'Answer'">
        <!-- //回答报价 -->
        <el-button @click="OfferCheck('Decline')">{{ $t('button.decline') }}</el-button>
        <el-button @click="setDialogType('NewOffer')">{{ $t('enum.newOffer') }}</el-button>
        <el-button type="primary" @click="OfferCheck('Accept')">{{ $t('enum.accept') }}</el-button>
      </div>
      <div v-else-if="dialogType == 'Decline'">
        <!-- //接受 -->
        <el-button @click="DialogSwitch">{{ $t('button.cancel') }}</el-button>
        <el-button type="primary" @click="OfferSave">{{ $t('button.save') }}</el-button>
      </div>
      <div v-else-if="dialogType == 'Processing'" :style="[CardInfo.SRStatus == 1 ? 'text-align: left;' : 'text-align: right;']">
        <div v-if="CardInfo.SRStatus <= 1">
          <div class="send_box">
            <!-- 图片 -->
            <div class="img-block">
              <!-- <div class="upload_ing"></div> -->
              <upload-images ref="UploadImages" uploadType="small"></upload-images>
            </div>
            <div class="text">
              <el-input @input.native="inputthandle" type="textarea" :rows="2" :placeholder="$t('tips.simplyDescribe')" maxlength="150" v-model="EquityVal"></el-input>
              <div class="f_button">
                <el-button ref="send" type="primary" class="send" :disabled='disabled' @click="EquitySave">{{ $t('button.send') }}</el-button>
              </div>
            </div>
          </div>
        </div>
        <div v-else>
          <el-button type="primary iffinish" @click="DialogSwitch">{{ $t('button.done') }}</el-button>
        </div>
      </div>
      <div v-else>
        <el-button type="primary" @click="DialogSwitch">{{ $t('button.done') }}</el-button>
      </div>
    </span>
  </el-dialog>
</template>

<script>
import { Swiper, SwiperSlide } from "vue-awesome-swiper";
import "swiper/css/swiper.css";

import UploadImages from '@/components/upload-images'
export default {
  name: 'DialogOffer',
  components: {
    Swiper,
    SwiperSlide,
    UploadImages
  },
  data() {
    return {
      OfferShow: false,
      OfferPrice: '',
      dialogType: '',
      CardInfo: {},
      disabled: false,
      ID: 0,
      swiperOption: {
        slidesPerView: 'auto',
        spaceBetween: 19,
      },
      EquityVal: '',
      Remark: ""//备注
    }
  },
  props: {
    OfferTitle: '',
    OfferList: []
  },
  watch: {},
  created() {
    // console.log('dialog created');
  },
  mounted() { },
  computed: {
    //  维权按钮类型
    SRBtnType: () => {
      return (type) => {
        /*
        srBtnType = 1    显示撤销维权的按钮        srBtnType = 2    显示重新维权的按钮
        srBtnType = 3    显示提起申诉的按钮        srBtnType = 4    显示撤销申诉的按钮
        */
        let btnval = 'Processing';
        switch (type) {
          case 1:
            btnval = 'Revoke';
            break;
          case 2:
            btnval = 'Open case';
            break;
          case 3:
            btnval = 'Open case';
            break;
          case 4:
            btnval = 'Revoke';
            break;
          case 6:
            btnval = 'Refund';
            break;
          case 7:
            btnval = 'Confirm Return Address';
            break;
          case 8:
            btnval = 'Wait Buyer Return';
            break;
          case 9:
            btnval = 'Refunded';
            break;
        }
        return btnval
      }
    }
  },
  methods: {
    dialogBox(type, obj) {
      let that = this;
      // console.log('CardInfo:', obj);
      switch (type) {
        case 'ViewDetails'://查看订单详细 
          that.dialogTitle = "Card Details";
          window.open(`/#/orders/detail?id=${obj.ID}`);
          return false;
          break;
      }
    },
    noClick() {
      // this.$message.warning("Sorry, You can't open case again.");
    },
    //获取输入长度
    inputthandle({ target }) {
      const that = this
      that.EquityVal = target.value
      // console.log(222,that.EquityVal.length)
      if (that.EquityVal.length > 5) {
        this.$refs.send.$el.style.background = '#5F6DAE'
      }
      else {
        this.$refs.send.$el.style.background = '#afb6d7'
      }
    },
    // 点击切换状态
    setDialogType(type) {
      this.dialogType = type;
    },
    /*议价弹框*/
    OfferCheck(type) {
      let that = this;
      let msg = '';
      let CardInfo = that.CardInfo;
      console.log("OfferCheck", CardInfo);
      if (type == 'Accept') {
        // msg = '<div class="p_txt">Do you want to Accept right now?</div>';
        msg = `<div class="dialog-check">`
          + `<div class='ock-row'>${this.$t('enum.congratulations')}!</div>`
          + `<div class='ock-row'>【${CardInfo.Title}】</div>`
          + `<div class='ock-row'>${this.$t('tips.soldAt')} USD ${CardInfo.USD_BuyPrice}</div>`
          + `<div class='ock-row'>${this.$t('tips.findOrders')}</div>`
          + `</div>`;
      } else {
        // msg = `<div class="p_txt">Do you want to Refuse this item?</div>`;
        msg = `<div class="p_txt">${this.$t('tips.declineOffer')}: USD ${CardInfo.USD_BuyPrice}</div>`;
      }
      let _title = '';
      switch (type) {
        case 'Accept'://拒绝
          _title = this.$t('enum.accept');
          break;
        case 'Decline'://接受
          _title = this.$t('enum.decline');
          break;
        default:
          break;
      }
      this.$confirm(msg, _title, {
        dangerouslyUseHTMLString: true,
        confirmButtonText: this.$t('button.yes'),
        cancelButtonText: this.$t('button.no'),
      }).then(() => {
        // console.log(type)
        if (type == 'Decline' || type == 'Accept') {
          let api = type == 'Decline' ? 'Refuse' : 'Approve';//直接拒绝/同意
          let params = {
            id: that.CardInfo['Bargain_ID']
          };
          if (api == 'Approve') { params['ApproveType'] = 2; }
          let fun = function (res) {
            //console.log(res)  
            let _type = 'success';
            if (res.result != 1) {
              _type = 'error';
            } else {
              that.$message({
                showClose: true,
                message: res.msg || _type,
                type: _type,
              });
            }
            that.OfferShow = false;
            // 获取tablelist GetDataOffer方法（获取我的商品列表）
            that.$parent.GetDataOffer();//page:offer.vue
          };
          that.$post(api, params)
            .then((res) => {
              console.log("axios-res:", res);
              fun(res);
            })
            .catch((err) => {
              console.log(err);
            });
        }
        // Yes    
      }).catch(() => {
        // No
      });
    },
    /*添加议价消息*/
    OfferSave() {
      let that = this;
      let params = {
        // CommodityID: that.CardInfo['Bargain_ID'],
        CommodityID: that.CardInfo['ID'],
        ReceiveID: that.CardInfo['Bargain_ID'],
        Price: that.$store.getters.priceExchange(that.OfferPrice),
        BargainType: 2,
        Remark: that.Remark,
        Images: '',
      };
      that.$post('BargainAdd', params)//添加议价消息
        .then((res) => {
          console.log("axios-res:", res);
          let _type = 'success';
          if (res.result != 1) {
            _type = 'error';
          } else {
            that.$message({
              showClose: true,
              message: res.msg || _type,
              type: _type,
            });
            that.OfferShow = false;
            // 获取tablelist GetDataOffer方法（获取我的商品列表）
            that.$parent.GetDataOffer();//page:offer.vue
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    /*维权 提交维权内容*/
    EquitySave() {
      let that = this;
      let _imageUrl = that.$refs.UploadImages.picList;
      let imgs = [];
      that.disabled = true
      if (_imageUrl.length) {
        _imageUrl.map((obj, k) => {
          // let cut = k < _imageUrl.length - 1 ? ',' : '';
          // imgs += obj['ImageUrl'] + cut;
          imgs.push(obj['ImageUrl']);
        });
      }
      let params = {
        OrderID: that.ID,
        Title: that.EquityVal,
        Images: imgs,
      };
      that.$post('AddSafeRight', params)//申请维权
        .then((res) => {
          console.log("axios-res:", res);
          let _type = 'success';
          that.GetSafeRights();//获取维权状态详细
          if (res.result != 1) {
            _type = 'error';
            that.disabled = false
          } else {
            // that.$message({
            //   showClose: true,
            //   message: res.msg || _type,
            //   // message: 'The case has been revoked!',
            //   type: _type,
            // });
            setTimeout(() => {
              that.$refs.UploadImages.picList = [];
              that.EquityVal = '';
              that.imgs = '';
              that.disabled = false
              that.$refs.send.$el.style.background = '#afb6d7'

              //that.OfferShow = false;
            }, 500);
          }
        })
        .catch((err) => {
          that.disabled = false
          console.log(err);
        });
    },
    /*维权 更改维权状态弹框*/
    ChangeSRBtnType(type) {
      /*
      srBtnType = 1    显示撤销维权的按钮      srBtnType = 2    显示重新维权的按钮
      srBtnType = 3    显示提起申诉的按钮      srBtnType = 4    显示撤销申诉的按钮
      srBtnType = 6    显示确认退款的按钮      srBtnType = 7    显示确认寄回地址的按钮
      srBtnType = 8    等待买家寄回商品      
      */
      let that = this;
      let oid = that.CardInfo.OrderDetail.ID, params = { OrderID: oid }, api = '';
      switch (type) {
        case 1:
          api = 'CancelSafrRight';
          break;
        case 2:
          api = 'ReOpenSafeRight';
          break;
        case 3:
          api = 'AppealSafrRight';
          break;
        case 4:
          api = 'CancelSafrRight';
          break;
      }
      if (type == 1 || type == 4) {
        that.$confirm('Are you sure to revoke this order?', 'Revoke', {
          dangerouslyUseHTMLString: true,
          confirmButtonText: this.$t('button.yes'),
          cancelButtonText: this.$t('button.no'),
        }).then(() => {
          // Yes
          that.srTypeRequest(api, params);
          if (type == 1) {
            that.$message({
              showClose: true,
              message: 'The case has been revoked!',
              type: 'success',
            });
          }

        }).catch(() => {
          // No
        });
      }else if(type == 6 || type == 7||type==8||type==9){
        console.log(that.CardInfo,'that.CardInfo')
        that.$router.push({
          path: '/orders/outcome/'+that.CardInfo.OrderDetail.ID
      })
      } else {
        that.srTypeRequest(api, params);
        that.$message({
          showClose: true,
          message: 'Case reopened!',
          type: 'success',
        });
      }
    },
    /*维权 更改维权状态 请求 */
    srTypeRequest(api, params) {
      let that = this;
      that.$post(api, params)
        .then((res) => {
          // console.log("axios-res:", res);
          if (res.result) {
            that.GetSafeRights();//获取维权状态详细
            // message: 'The case has been revoked!',
            // that.$message({
            //   showClose: true,
            //   message: res.msg || 'Success',
            //   type: 'success',
            // });
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    /* 获取维权状态详细 */
    GetSafeRights() {
      let that = this;
      that.$get('GetSafeRights', `?orderId=${that.CardInfo.OrderDetail.ID}&pageIndex=1&pageSize=999&applyType=0`)
        .then((res) => {
          if (res.result) {
            let _data = res.data;
            // 双向数据绑定，修改数据，页面不刷新
            that.$set(that.CardInfo, 'SRBtnType', _data.SRBtnType);
            that.$set(that.CardInfo, 'SRStatus', _data.SRStatus);
            that.$set(that.CardInfo, 'StatusMsg', _data.StatusMsg);
            that.$set(that.CardInfo, 'SRResult', _data.SRResult);
            that.$set(that.CardInfo, 'objs', _data.objs);
            let t = _data.SRStatus == 1 ? this.$t('enum.disputing') + '...' : this.$t('enum.disputed');
            that.$parent.setOfferTitle(t);
            console.log('that.CardInfo', that.CardInfo)
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    // tablelist 的 DialogSwitch（议价弹框）
    DialogSwitch(page) {
      this.$emit('DialogSwitch', 'DialogOffer');
    },
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.my-price {
  /* padding-bottom: 15px; */
  padding: 0 10px 15px;
}

.dialog_box {
  padding: 0 30px;
  width: 100%;
}

.dialog_box_Processing {
  padding: 0;
}

/deep/.processing .el-dialog {
  height: 90vh;
  /* min-height: 640px; */
  margin-top: 10vh;
  /* position: relative; */
}

/deep/.processing .el-dialog__body {
  background: #f7f7f7;
  padding: 0 12px;
  /* height: 68%; */
  /* position: relative; */
}

/* /deep/.processing.processed .el-dialog__body {
  height: 80%;
} */

/deep/.processing .dialog_box {
  margin: 0;
  /* height: 100%; */
}

/deep/.processing .el-dialog__footer {
  padding: 10px;
}

.like_slide {
  width: 88px;
  height: 88px;
}

.img-block {
  padding-bottom: 5px;
}

.order_index_box {
  padding: 0 12px 8px 12px;
  background: #fff;
  border-radius: 4px;
}

.order_index {
  height: 40px;
  line-height: 40px;
  display: flex;
  font-size: 14px;
  justify-content: space-between;
}

.color_333 {
  color: #333;
}

.order-user {
  display: flex;
  justify-content: flex-end;
  align-items: center;
}

.seller_img {
  width: 22px;
  height: 22px;
  margin: 0 5px;
  border-radius: 50%;
}

.commodity_index_box,
.Process_box,
.seller_reply,
.user_reply {
  display: flex;
}

.Process_box {
  width: 100%;
  position: absolute;
  bottom: 0;
  display: flex;
  justify-content: space-between;
}

.commodity_index {
  justify-content: space-between;
  position: relative;
  padding: 0 12px 0 0;
  width: 396px;
}

.commodity_img {
  width: 88px;
  height: 88px;
  border-radius: 3px;
  margin-right: 10px;
  border: 1px solid #e9e9e9;
  /* display: flex; */
  justify-content: center;
  align-content: center;
  align-items: center;
  background: #f7f7f7;
  position: relative;
}

.commodity_img img {
  width: 100%;
  height: 100%;
  /* height: auto; */
  border-radius: 3px;
  object-fit: contain;
}

.commodity_title {
  font-size: 16px;
  font-weight: normal;
  word-break: break-word;
}

.Order_price {
  height: 32px;
  font-size: 12px;
  line-height: 45px;
  overflow: hidden;
}

.Process {
  height: 32px;
  font-size: 12px;
  padding: 9px 12px;
  display: inline-block;
  margin: 0 12px 0 0;
  border: 1px solid #c8c8c8;
  border-radius: 4px;
}

.noClick {
  cursor: default;
}

.Processing_box {
  height: 100%;
  overflow-y: scroll;
}

.time {
  text-align: center;
  width: 100%;
  display: block;
  padding: 16px 0;
}

.seller_reply img,
.user_reply img {
  width: 32px;
  height: 32px;
  border-radius: 4px;
}

.seller_reply,
.user_reply {
  margin: 0 0 16px 0;
}

.seller_reply .text,
.user_reply .text {
  min-height: 40px;
  max-width: 332px;
  background: #ffffff;
  z-index: 2;
  margin: 0 0 0 -6px;
  padding: 0 0 0 12px;
}

.text span {
  display: block;
  padding: 12px 12px 12px 0;
}

.more {
  width: 12px;
  height: 12px;
  display: inline-block;
  background: #fff;
  transform: rotate(45deg);
  content: "";
  border-left: 0;
  border-top: 0;
  z-index: 1;
  margin: 12px 0;
}

.seller_reply {
  margin: 0 0 0 8px;
}

.seller_reply_box {
  min-height: 40px;
  display: flex;
  margin: 0 0 0 10px;
}

.user_reply_box {
  display: flex;
  min-height: 40px;
  margin: 0 10px 0 0;
}

.user_reply_box .more {
  width: 12px;
  height: 12px;
  display: inline-block;
  background: #fff;
  transform: rotate(45deg);
  content: "";
  border-left: 0;
  border-top: 0;
  z-index: 1;
  margin: 12px 0px 12px -6px;
  border-radius: 1px;
}

.text img {
  width: 100px;
  height: 100px;
  border-radius: 4px;
  margin: 0 4px 0 0;
}

.text_img {
  height: 100px;
}

.user_reply {
  margin: 0 8px 0 0;
  justify-content: end;
  flex-direction: row-reverse;
}

/* .upload_ing {
  width: 24px;
  height: 24px;
  background: url(../../../static/images/icons/icon_picture.svg) no-repeat;
  display: inline-block;
  cursor: pointer;
} */
.send {
  background: #afb6d7;
  color: #fff;
  border: none;
  /* position: absolute;
  right: 0; */
}

.send_box {
  background: #ffffff;
  position: relative;
}

.send_box img {
  width: 100%;
}

.processing-main {
  display: flex;
  flex-direction: column;
  height: 100%;
}

.process-btn {
  cursor: pointer;
}

/deep/.text .el-textarea__inner {
  border: none;
}

.Processing_box .text {
  border-radius: 4px;
}

/deep/ .el-dialog {
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  margin: 0px !important;
}

.commodity_num {
  height: 20px;
  width: 100%;
  display: block;
  background: rgba(0, 0, 0, 0.5);
  color: #f7f7f7;
  font-size: 12px;
  line-height: 1.5;
  text-align: center;
  position: absolute;
  bottom: 0;
  border-bottom-left-radius: 3px;
  border-bottom-right-radius: 3px;
}

.f_button {
  margin-top: 10px;
}

.height114 {
  height: calc(90vh - 114px);
}

.height204 {
  height: calc(90vh - 204px);
}

.dialog_box_Answer {
  padding-bottom: 15px;
}

.sh_fee {
  width: 100%;
  line-height: 1.6;
  justify-content: flex-start;
}

.offer_block {
  display: flex;
  flex-direction: column;
  justify-content: center;
  justify-items: center;
  align-items: center;
  line-height: 1.6;
  padding-bottom: 10px;
}

.offer_buyer {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-content: center;
  align-items: center;
  padding-bottom: 10px;
}

.user_avatar {
  width: 25px;
  height: 25px;
  margin: 0 10px 0 0;
}

.offer-view {
  font-size: 12px;
  font-weight: bold;
}

.offer_price {
  font-size: 28px;
  font-weight: bold;
}

.offer_title {
  padding: 0 10px 0 0;
}

.my_new_offer {
  display: flex;
  align-items: center;
  align-content: center;
  border-bottom: 1px solid #eee;
}

.my_new_offer .enter_price {
  width: 155px;
}

/deep/ .my_new_offer .enter_price .el-input__inner {
  border: none;
  padding: 0 5px;
  text-align: center;
  font-size: 28px;
  font-weight: bold;
}

/deep/ .el-table td.el-table__cell,
/deep/ .el-table th.el-table__cell.is-leaf {
  border-bottom: 1px solid #EBEEF5;
}

.offer_remark {
  padding: 15px 0;
  width: 100%;
}

.tab-row {
  word-break: break-word;
}
</style>



// WEBPACK FOOTER //
// src/components/dialog/dialog-offer.vue